import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider.jsx'
import { ROLE_HOMES } from '../constants/index.js'

// Maps the signed-in user's role to their landing route. The map itself lives
// in `src/constants/roles.js` so adding a new role home only touches one file.
export default function RoleHome() {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  const role = (user.role || '').toLowerCase()
  const dest = ROLE_HOMES[role] || '/unauthorized'
  return <Navigate to={dest} replace />
}
